module.exports = __webpack_public_path__ + "static/media/logo2.c6213634.png";